import { DataSourceWiki, Distribution } from 'src/api/data-sources';

export const formatNumberToKMB = (value: number): string => {
  const absValue = Math.abs(value);

  const format = (num: number, suffix: string) => {
    // Convert to string with 2 decimal places
    const formatted = num.toFixed(2);
    // Remove trailing zeros after decimal point
    const trimmed = formatted.replace(/\.?0+$/, '');
    return trimmed + suffix;
  };

  if (absValue >= 1_000_000_000) {
    return format(value / 1_000_000_000, 'B');
  }
  if (absValue >= 1_000_000) {
    return format(value / 1_000_000, 'M');
  }
  if (absValue >= 1_000) {
    return format(value / 1_000, 'K');
  }
  return value.toLocaleString();
};

export const capitalizeFirstLetter = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const findDemographic = (
  data: DataSourceWiki | undefined,
  metric: string,
): Distribution | undefined => {
  return data?.metadata?.demographics?.find(
    (demo) => demo.metric.toLowerCase() === metric.toLowerCase(),
  );
};

export const formatWikiDataForChart = (
  data: DataSourceWiki | undefined,
  metric: string,
  isCategorical = true,
  excludeUnknown = false,
): { label: string | number; value: number }[] => {
  let result =
    Object.entries(
      data?.metadata?.demographics?.find(
        (demo) => demo.metric.toLowerCase() === metric.toLocaleLowerCase(),
      )?.distribution || {},
    )
      .filter(
        ([key, _]) => key !== 'null' && (!excludeUnknown || (excludeUnknown && key !== 'Unknown')),
      )
      .map(([key, value]) => ({
        label: isCategorical ? key : parseInt(key),
        value,
      })) || [];

  if (!isCategorical) {
    result = result.concat([{ label: 0, value: 0 }]);
  }

  return result;
};

export const getTotalCount = (data: DataSourceWiki | undefined, metric: string): number => {
  const demographic = findDemographic(data, metric);
  return demographic ? Object.values(demographic.distribution).reduce((a, b) => a + b, 0) : 0;
};

export const formatDateRange = (
  dateRange: { min_date: string; max_date: string } | undefined,
): string => {
  if (!dateRange) return '';
  const { min_date, max_date } = dateRange;
  return `${
    min_date
      ? new Date(min_date).toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
        })
      : ''
  } - ${
    max_date
      ? new Date(max_date).toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
        })
      : ''
  }`;
};

export const formatLabel = (label: string) => {
  const split = label.split('_').join(' ');
  // Capitalize all words
  return split.replace(/\b\w/g, (char) => char.toUpperCase());
};
